import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ title, description, icon, iconColor, onClick }) => {
  return (
    <div
      onClick={onClick}
      className="bg-card border border-border rounded-lg p-6 cursor-pointer transition-all duration-200 hover:shadow-interactive hover:border-primary/30 group"
    >
      <div className="flex items-start gap-4">
        <div
          className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-transform duration-200 group-hover:scale-110"
          style={{ backgroundColor: `${iconColor}15` }}
        >
          <Icon name={icon} size={24} color={iconColor} />
        </div>
        <div className="flex-1">
          <h4 className="text-base font-semibold text-foreground mb-1">{title}</h4>
          <p className="text-sm text-muted-foreground">{description}</p>
        </div>
        <Icon
          name="ChevronRight"
          size={20}
          className="text-muted-foreground group-hover:text-primary transition-colors duration-200"
        />
      </div>
    </div>
  );
};

export default QuickActionCard;